import { render } from "./InputHint.vue?vue&type=template&id=1d8e36ba"
import script from "./InputHint.vue?vue&type=script&lang=js"
export * from "./InputHint.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__